import { useTranslation } from 'react-i18next';

export const CheckKeyboard: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col rounded-lg bg-white p-8">
      <div className="font-semibold text-sm">
        <p>{t('page.mockTest.keyboardCheck.title')}</p>
        <p>{t('page.mockTest.keyboardCheck.keyboardCheckDescription')}</p>
        <p>{t('page.mockTest.keyboardCheck.keyboardInstruction1')}</p>
        <p>{t('page.mockTest.keyboardCheck.keyboardInstruction2')}</p>
        <p>{t('page.mockTest.keyboardCheck.keyboardInstruction3')}</p>
      </div>
      <img className="mt-5" src="/images/keyboard_check.png" width={455} height={181} />
    </div>
  );
};
